import ButtonTopBar from "assets/styles/buttonTopBar";
import {useAppDispatch, useAppSelector} from "store";
import {configActions, useConfigState} from "store/config";

const ButtonExibeEmpresa = () => {
  const config = useAppSelector(useConfigState);
  const appDispatch = useAppDispatch();
  return (
    <ButtonTopBar
      variant={"contained"}
      color={"inherit"}
      onClick={() => appDispatch(configActions.setModalConfig({modalConfig: true}))}
      sx={{
        m: 1,
        width: {
          lg: 400,
        },
        height: {
          lg: 35,
        },
      }}
    >
      {config.parametros && config.parametros.codigoUnico ? `${config.parametros.codigoUnico} - ${config.parametros.grupo}` : "Não selecionado"}
    </ButtonTopBar>
  );
};
export default ButtonExibeEmpresa;
